/*
 *
 *  actions
 *
 */

import {
  LOAD_RECORDS_VALID_CACHE,
  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,
  LOAD_EMPLOYEE,
  LOAD_EMPLOYEE_SUCCESS,
  LOAD_EMPLOYEE_ERROR,
  LOAD_DELEGATION_SUCCESS,
  LOAD_DELEGATION_ERROR,
  LOAD_DELEGATION,
  LOAD_PROCESS_STATUS,
  LOAD_PROCESS_STATUS_SUCCESS,
  LOAD_PROCESS_STATUS_ERROR,
  LOAD_UPDATE_DELEGATION,
  LOAD_UPDATE_DELEGATION_SUCCESS,
  LOAD_UPDATE_DELEGATION_ERROR,
  LOAD_UPDATE_LPND,
  LOAD_UPDATE_LPND_SUCCESS,
  LOAD_UPDATE_LPND_ERROR,
  DELETE_RECORD,
  DELETE_RECORD_ERROR,
  DELETE_RECORD_SUCCESS,

  APPLY_DELEGATION_DETAILS,
  APPLY_DELEGATION_DETAILS_SUCCESS,
  APPLY_DELEGATION_DETAILS_ERROR,
} from "./constants"

export function loadRecordsCacheHit() {
  return {
    type: LOAD_RECORDS_VALID_CACHE,
  }
}

export function loadRecordsMetaData() {
  return {
    type: LOAD_RECORDS_META_DATA,
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadRecordsMetaDataSuccess(delegationMetaData) {
  return {
    type: LOAD_RECORDS_META_DATA_SUCCESS,
    delegationMetaData,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadRecordsMetaDataError(error) {
  return {
    type: LOAD_RECORDS_META_DATA_ERROR,
    error,
  }
}

//Employee list
/**
 *
 * @param {integer} id
 * @returns
 */
export function loadEmployee() {
  return {
    type: LOAD_EMPLOYEE,
  }
}

export function loadEmployeeSuccess(employee_list) {
  return {
    type: LOAD_EMPLOYEE_SUCCESS,
    employee_list,
  }
}

/**
 * @param {string} error
 */

export function loadEmployeeError(error) {
  return {
    type: LOAD_EMPLOYEE_ERROR,
    error,
  }
}

// delegation
export function loadDelegation(searchvalue) {
  return {
    type: LOAD_DELEGATION,
    searchvalue,
  }
}
export function loadDelegationSuccess(delegation_details) {
  return {
    type: LOAD_DELEGATION_SUCCESS,
    delegation_details,
  }
}
export function loadDelegationError(error) {
  return {
    type: LOAD_DELEGATION_ERROR,
    error,
  }
}
//UPDATE DELEGATION
export function loadUpdateDelegation(update_Delegation) {
  return {
    type: LOAD_UPDATE_DELEGATION,
    update_Delegation,
  }
}
export function loadUpdateDelegationSuccess(update_Delegation, success) {
  return {
    type: LOAD_UPDATE_DELEGATION_SUCCESS,
    update_Delegation,
    success,
  }
}
export function loadUpdateDelegationError(error) {
  return {
    type: LOAD_UPDATE_DELEGATION_ERROR,
    error,
  }
}
//UPDATE LPND
export function loadUpdateLPND(statusDetails) {
  return {
    type: LOAD_UPDATE_LPND,
    statusDetails,
  }
}
export function loadUpdateLPNDSuccess(statusDetails) {
  return {
    type: LOAD_UPDATE_LPND_SUCCESS,
    statusDetails,
  }
}
export function loadUpdateLPNDError(error) {
  return {
    type: LOAD_UPDATE_LPND_ERROR,
    error,
  }
}
//PROCESS STATUS
export function loadProcessStatus(mode) {
  return {
    type: LOAD_PROCESS_STATUS,
    mode,
  }
}

/**
 * @param {object}
 * @param {object}
 */
export function loadProcessStatusSuccess(process_status) {
  return {
    type: LOAD_PROCESS_STATUS_SUCCESS,
    process_status,
  }
}

/**
 * @param {string} error
 */
export function loadProcessStatusError(error) {
  return {
    type: LOAD_PROCESS_STATUS_ERROR,
    error,
  }
}
//DELETE SECTION

export function deleteRecord(deleteData) {
  return {
    type: DELETE_RECORD,
   deleteData
  }
}

/**
 * 
 * @param {integer} id 
 * @param {string} success 
 * @returns 
 */
export function deleteRecordSuccess(id, success) {
  return {
    type: DELETE_RECORD_SUCCESS,
    id,
    success
  }
}

/**
 * @param {string} error 
 */
export function deleteRecordError(error) {
  return {
    type: DELETE_RECORD_ERROR,
    error
  }
}

//Apply Delegations details
/**
 *
 * @param {integer} id
 * @returns
 */
export function applyDelegationList(applyDelegationDetails) {
  return {
    type: APPLY_DELEGATION_DETAILS,
    applyDelegationDetails,
  }
}

export function applyDelegationListSuccess(applyDelegationDetails, success) {
  return {
    type: APPLY_DELEGATION_DETAILS_SUCCESS,
    applyDelegationDetails,
    success,
  }
}

/**
 * @param {string} error
 */

export function applyDelegationListError(error) {
  return {
    type: APPLY_DELEGATION_DETAILS_ERROR,
    error,
  }
}

const actions = {
  loadRecordsCacheHit,
  loadRecordsMetaData,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,

  loadEmployee,
  loadEmployeeSuccess,
  loadEmployeeError,

  loadDelegation,
  loadDelegationSuccess,
  loadDelegationError,

  loadProcessStatus,
  loadProcessStatusSuccess,
  loadProcessStatusError,

  deleteRecord,
  deleteRecordSuccess,
  deleteRecordError
}

export default actions
